module.exports = __webpack_public_path__ + "img/dummy.fc889256.webp";